import { HttpHeaders } from '@angular/common/http'
import { FuseqService } from './fuseq.service'
import { Injectable } from '@angular/core'
import { FuseqSessionService } from './session.service'
import { environment } from '../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class FuseqHeaders {
  constructor (
    private readonly fuseqService: FuseqService,
    private readonly fuseqUser: FuseqSessionService
  ) {}

  setHeaders (type: string) {
    let headerObject = new HttpHeaders().set('Content-Type', 'application/json')
    headerObject = headerObject.append('Authorization', this.fuseqService.getBackEndAuthentication())
    headerObject = headerObject.append('Authorization-Type', 'Preemptive')
    headerObject = headerObject.append('Access-Control-Allow-Headers', 'Content-Type')
    headerObject = headerObject.append('Access-Control-Allow-Methods', type + ', OPTIONS')
    headerObject = headerObject.append('Access-Control-Allow-Origin', '*')
    return { headers: headerObject }
  }

  setTokenHeaders (type: string) {
    const currentUser = this.fuseqUser.session
    let headerObject = new HttpHeaders()
    headerObject = headerObject.append('Content-Type', 'application/json')
    headerObject = headerObject.append('Authorization', this.fuseqService.getBackEndAuthentication())
    headerObject = headerObject.append('Authorization-Type', 'Preemptive')
    headerObject = headerObject.append('Access-Control-Allow-Headers', 'Content-Type')
    headerObject = headerObject.append('Access-Control-Allow-Methods', type + ', OPTIONS')
    headerObject = headerObject.append('Access-Control-Allow-Origin', '*')
    if (!!currentUser && !!currentUser.token) {
      headerObject = headerObject.append('AuthToken', currentUser.token)
    }
    return { headers: headerObject }
  }

  setRtuApiKeyHeaders (type: string) {
    const headers = this.setTokenHeaders(type)
    return { headers: headers.headers.append('X-RTU-Key', environment.RTU_API_KEY) }
  }
}
